import React from 'react'

const IconReply = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
      <path
        d='M14.8463 17.6542L20.5 12.0004L14.8463 6.34668L13.7923 7.40043L17.6423 11.2504H5V7.25043H3.5V12.7504H17.6423L13.7923 16.6004L14.8463 17.6542Z'
        fill='black'
      />

      <defs>
        <clipPath id='clip0_16748_458512'>
          <rect width='24' height='24' rx='4' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}

export default IconReply
